import React, { FC } from 'react';
import styled from 'styled-components';

import { mobile, tablet } from 'styles/breakpoints';
import { QuizAnswerButton } from 'components';
import { Question, QuestionOption } from 'types/quiz';
import { Typography } from 'utils/theme';

import Header from './Header';

interface SingleProps {
  question: Question;
  selectedOptions: QuestionOption[];
  disabled: boolean;
  onSelect: (option: QuestionOption) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  flex-direction: column;
  display: flex;
  width: 25rem;

  button:nth-child(1n):not(:last-child) {
    margin-bottom: 1rem;
  }

  @media ${mobile} {
    justify-content: flex-end;
    padding-bottom: calc(7.5rem - 1rem);
    width: 100%;
  }
`;

const Single: FC<SingleProps> = ({
  question,
  selectedOptions,
  disabled,
  onSelect,
  ...props
}) => {
  const selected = (option: QuestionOption) =>
    selectedOptions.some(
      selectedOption => selectedOption.value === option.value,
    );

  return (
    <Container {...props}>
      <Header
        title={question.label}
        subtitle={question?.optionsLabel ?? ''}
        imageUrl={question.image}
        imageAlt={question.alt}
        optionsLabelFont={question.optionsLabelFont as Typography}
        imageHeightDesktop={question.imageHeightDesktop}
        imageHeightTablet={question.imageHeightTablet}
        imageHeightMobile={question.imageHeightMobile}
      />
      <ButtonsContainer>
        {question.options?.map((option, index) => (
          <QuizAnswerButton
            key={index}
            disabled={disabled}
            onClick={() => onSelect(option)}
            active={selected(option)}
          >
            {option.label}
          </QuizAnswerButton>
        ))}
      </ButtonsContainer>
    </Container>
  );
};

export default Single;
